import { useState, useEffect, useRef } from 'react'
import { IconClose } from './Icons'
import './Toast.css'

const AUTO_DISMISS_MS = 5000

export function Toast({
  id,
  message,
  variant = 'info',
  duration = AUTO_DISMISS_MS,
  onDismiss,
  type = 'message',
  inputDefaultValue = '',
  inputPlaceholder = '',
  confirmLabel = 'אישור',
  cancelLabel = 'ביטול',
  onSubmit,
  onCancel,
  onConfirm,
}) {
  const [inputValue, setInputValue] = useState(inputDefaultValue)
  const inputRef = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    if (type !== 'message' || duration <= 0) return
    timerRef.current = setTimeout(() => onDismiss?.(id), duration)
    return () => { if (timerRef.current) clearTimeout(timerRef.current) }
  }, [id, type, duration, onDismiss])

  useEffect(() => {
    if ((type === 'prompt' || type === 'confirm') && inputRef.current) inputRef.current.focus()
  }, [type])

  const handleSubmit = () => {
    if (type === 'prompt') onSubmit?.(inputValue.trim() || inputDefaultValue)
    else if (type === 'confirm') onConfirm?.()
    onDismiss?.(id)
  }

  const handleCancel = () => {
    if (type === 'prompt') onCancel?.()
    else if (type === 'confirm') onCancel?.()
    onDismiss?.(id)
  }

  const confirmLabelResolved = type === 'confirm' ? (confirmLabel || 'אישור') : confirmLabel
  const cancelLabelResolved = cancelLabel || 'ביטול'

  return (
    <div className={`toast toast-${variant} toast-${type}`} role="alert">
      <div className="toast-content">
        <p className="toast-message">{message}</p>
        {type === 'prompt' && (
          <input
            ref={inputRef}
            type="text"
            className="toast-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={inputPlaceholder}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        )}
        {(type === 'prompt' || type === 'confirm') && (
          <div className="toast-actions">
            <button type="button" className="toast-btn toast-cancel" onClick={handleCancel}>
              {cancelLabelResolved}
            </button>
            <button type="button" className="toast-btn toast-confirm primary" onClick={handleSubmit}>
              {confirmLabelResolved}
            </button>
          </div>
        )}
      </div>
      {type === 'message' && (
        <button type="button" className="toast-close" onClick={() => onDismiss?.(id)} aria-label="סגור">
          <IconClose size={18} />
        </button>
      )}
    </div>
  )
}

export function ToastContainer({ toasts, removeToast }) {
  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((t) => (
        <Toast key={t.id} {...t} onDismiss={removeToast} />
      ))}
    </div>
  )
}
